export enum ChatNav {
    MENU = 'menu',
    CHAT_BOX = 'chatBox',
}
